import React from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import classes from './ChipsButtonAll.module.scss';

const ChipsButtonAll = ({ length, onClickChips }) => {
  const language = useUserState().user.language;

  const params = useParams();
  return (
    <div
      className={cn(
        classes.underlineChips,
        !params.releaseId && classes.underlineChips_isChecked
      )}
    >
      <div className={classes.chipsButtonWrap}>
        <button
          type="button"
          className={classes.chipsButtonAll}
          onClick={() => onClickChips('allReleaseId')}
        >
          <p className={classes.nameAll}>
            {t('chipsButtonAll', 'ALL', language)}
          </p>
          <p className={classes.optionAll}>({length})</p>
        </button>
      </div>
    </div>
  );
};

ChipsButtonAll.propTypes = {
  length: PropTypes.number.isRequired,
  onClickChips: PropTypes.func.isRequired
};

export default ChipsButtonAll;
